import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { initialize } from "utils/analytics";
import decryptKey from "../servos/decryptionHelpers";

function AnalyticsProvider({ children }) {
  const googleTagId = useSelector(
    (state) => state.locations.currentLocation?.googleTagId
  );
  const metaPixelId = useSelector(
    (state) => state.locations.currentLocation?.metaPixelId
  );

  const measurementId = useMemo(
    () => (googleTagId ? decryptKey(googleTagId) : null),
    [googleTagId]
  );
  const pixelId = useMemo(
    () => (metaPixelId ? decryptKey(metaPixelId) : null),
    [metaPixelId]
  );

  const debug =
    typeof window !== "undefined" &&
    window.location.hostname === "localhost";

  useEffect(() => {
    if (measurementId || pixelId) {
      initialize({ measurementId, pixelId, debug });
    }
  }, [measurementId, pixelId, debug]);

  return children;
}

export default AnalyticsProvider;
